<p>Setting things up... You will be redirected shortly. If the redirection does not happen within 5 seconds, <a [href]="environment.clientUrl" (click)="redirect($event)"> click here</a>.</p>
